import React, { type JSX } from 'react';

export interface Props {
  className: string;
}

const Pin: React.FC<Props> = ({ className }: Props): JSX.Element => (
  <span className={`Pin ${className}`}>
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
    >
      <path
        className="shape"
        d="M32,0.5c-12.3,0-22.3,10-22.3,22.3c0,15,20.9,40.6,22.3,40.6c1.4,0,22.3-25.6,22.3-40.6
	C54.3,10.5,44.3,0.5,32,0.5z M32,33.6c-6.3,0-11.4-5.1-11.4-11.4c0-6.3,5.1-11.4,11.4-11.4c6.3,0,11.4,5.1,11.4,11.4
	C43.4,28.5,38.3,33.6,32,33.6z"
      />
      <path
        className="right-highlight"
        d="M50.3,22.9c0-10.1-8.2-18.3-18.3-18.3c0,0,0,0,0,0v3c0,0,0,0,0,0
	c8.1,0,14.7,6.6,14.7,14.7c0,8.1-6.6,14.7-14.7,14.7c0,0,0,0,0,0v21c0,0,0,0,0,0c2.2-2.6,5.8-7.3,9.2-12.7
	C47,35.9,50.3,28,50.3,22.9z"
      />
      <path
        className="left-highlight"
        d="M32,7.6v-3c-10.1,0-18.3,8.2-18.3,18.3c0,5.1,3.2,13.1,9.1,22.3c3.4,5.4,7,10,9.2,12.7v-21
	c-8.1,0-14.6-6.6-14.6-14.7C17.3,14.1,23.9,7.6,32,7.6z"
      />
    </svg>
  </span>
);

export default Pin;
